import register from '../../../../global/js/registry';
export default register('o-accordion', () => import(/* webpackMode: "lazy" */ './o-accordion.controller'));
